export default __webpack_public_path__ + "static/media/a011-market-4.2f08efda.svg";